import type { FormItemConfig } from '@ms/shared-components/comps/CompsForm';
import type { Dataset } from '../../../services/aiConfigService';

const methodTypeOptions = [
  { label: 'Hook', value: 'hook' },
  { label: 'Service', value: 'service' },
  { label: 'Function', value: 'function' },
];

const dataFormatOptions = [
  { label: '数组', value: 'array' },
  { label: '二维数组', value: 'array2d' },
  { label: '对象', value: 'object' },
  { label: '嵌套对象', value: 'nested' },
  { label: '混合格式', value: 'mixed' },
];

export const getFormItems = (editingRecord?: Dataset | null): FormItemConfig[] => [
  {
    name: 'datasetId',
    label: '数据集ID',
    type: 'input',
    rules: [{ required: true, message: '请输入数据集ID' }],
    props: { disabled: !!editingRecord },
  },
  {
    name: 'name',
    label: '数据集名称',
    type: 'input',
    rules: [{ required: true, message: '请输入数据集名称' }],
  },
  {
    name: 'description',
    label: '描述',
    type: 'textarea',
    props: { rows: 3 },
  },
  {
    name: 'methodType',
    label: '方法类型',
    type: 'select',
    rules: [{ required: true, message: '请选择方法类型' }],
    options: methodTypeOptions,
  },
  {
    name: 'methodName',
    label: '方法名称',
    type: 'input',
    rules: [{ required: true, message: '请输入方法名称' }],
  },
  { name: 'serviceName', label: '所属服务', type: 'input' },
  {
    name: 'dataFormat',
    label: '数据格式',
    type: 'select',
    options: dataFormatOptions,
  },
  {
    name: 'dataPath',
    label: '数据路径',
    type: 'input',
    props: { placeholder: '如: data, result.items, root' },
  },
  {
    name: 'paramTemplate',
    label: '参数模板 (JSON)',
    type: 'textarea',
    props: {
      rows: 4,
      placeholder: '{"date": "{date}", "hotelId": "{hotelId}"}',
    },
  },
  {
    name: 'defaultParams',
    label: '默认参数 (JSON)',
    type: 'textarea',
    props: { rows: 4, placeholder: '{"date": "today"}' },
  },
  {
    name: 'isActive',
    label: '是否启用',
    type: 'switch',
    valuePropName: 'checked',
    props: { checkedChildren: '启用', unCheckedChildren: '禁用' },
  },
];

export const formConfig = {
  layout: 'horizontal' as const,
  contentPadding: 0,
};
